import React, { Component } from 'react';
import "./payment.css"
import Cards from 'react-credit-cards';
import 'react-credit-cards/es/styles-compiled.css';


class Payment extends Component {

constructor(props) {
    super(props);

    this.state = {
      number: '',
      name: '',
      expiry: '',
      cvc: '',
      focused: '',
      public:[],
      tuitions :[],
      school_id: "",
      school:[],
      noerorrpage :  true
    };
  }

  // "5b7a078490e2240014bba1ac"
  componentDidMount() {
    this.props.noerorrpage(this.state.noerorrpage)
    const { match: { params } } = this.props;
        console.log("params.userId",params.id,"search",params)
        this.setState({
          noticepop : false,
          loadingnews :true
    })
    console.log("public users id", this.state.pamaschange)
    // console.log("get payment",  Auth.getProfile().userId)
    const requestOptions = {
        method: 'GET', 
        headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*'  },
    };
    console.log("public users param", params.id)
    fetch("https://uvunebeta.herokuapp.com/payment/"+params.id, requestOptions)
    .then(res => res.json())
    .then((result)=>{
        if(result){
            console.log("paymemt ", result)
            this.setState({
                loadingnews :false,
                tuitions : result,
                school_id :  result.owner
            })
            console.log("id school",  this.state.school_id)
          fetch("https://uvunebeta.herokuapp.com/users/"+this.state.school_id, requestOptions)
          .then(res => res.json())
          .then((result)=>{
            if(result){
                console.log("paymemt users", result)
                this.setState({
                    loadingnews :false,
                    school : result,
                
                })
              }else{
                this.setState({
                    lloadingnews  :true
                }) 
            }
        })
        }else{
            this.setState({
                lloadingnews  :true
            }) 
        }
    })

    // Payment.formatCardNumber(document.querySelector('[name="number"]'));
    // Payment.formatCardExpiry(document.querySelector('[name="expiry"]'));
    // Payment.formatCardCVC(document.querySelector('[name="cvc"]'));
  }


  handleInputFocus = ({ target }) => {
    this.setState({
      focused: target.name,
    });
  };

  handleInputChange = ({ target }) => {
    if (target.name === 'number') {
      this.setState({
        [target.name]: target.value.replace(/ /g, ''),
      });
    }
    else if (target.name === 'expiry') {
      this.setState({
        [target.name]: target.value.replace(/ |\//g, ''),
      });
    }
    else {
      this.setState({
        [target.name]: target.value,
      });
    }
  };

  makePayment = (event)=>{
    event.preventDefault()
    console.log("name value", this.name.value)
  }

  handleCallback(type, isValid) {
    console.log(type, isValid); //eslint-disable-line no-console
  }

  

  render() {
    const { name, number, expiry, cvc, focused } = this.state;
    return (
     <div className="Payment">  
     
         <div className="payment-public-body">
            <div className="payment-public-head"> 
                  <p ><b> Enter your payment information </b></p>
            </div>    
            
             <div className="payment-public-body-sub">
        
             <div className="columns">
                <div className="column is-half">
                    <div className="payment-public-card"> 
                        <Cards
                                number={number}
                                name={name}
                                expiry={expiry}
                                cvc={cvc}
                                focused={focused}
                                required
                                // callback={this.handleCallback}
                            />
                    </div>
                </div>
                <div className="column is-half">
                    <div className="payment-public-body-details">
                       You  are  paying  <b className="parastament-payment">( N{this.state.tuitions.amount} )
                       </b> for this<b className="parastament-payment"> ({this.state.tuitions.name}) </b> In this school
                        <b className="parastament-payment">   ({this.state.school.display_name}) </b>
                    </div>
                    <div className="payment-public-body-amout">
                     Total  <i className="fas fa-money-bill-alt"> </i> :   <b>  N{this.state.tuitions.amount} </b>
                    </div>
                </div>
              </div>
                
                 <div className="payment-public-body-head">
                 <i className="far fa-credit-card"></i> Enter payment info below
                 </div>
                  <div className="payment-public-body-input">
                  <form   onSubmit={this.makePayment}>
                    <div className="columns">
                          <div className="column is-half">
                            
                                      <input 
                                      className="input is-primary"
                                          type="number"
                                          name="number"
                                          placeholder="Card Number"
                                          onKeyUp={this.handleInputChange}
                                          onFocus={this.handleInputFocus}
                                          required
                                          
                                      />
                                      {/* <div>E.g.: 49..., 51..., 36..., 37...</div>
                                      */}
                              </div> 
                              <div className="column">
                              <div className="name-date-csv-payment">
                                        <div>
                                        <input
                                                className="input is-primary"
                                                type="tel"
                                                name="expiry"
                                                placeholder="Valid Thru"
                                                onKeyUp={this.handleInputChange}
                                                onFocus={this.handleInputFocus}
                                                required
                                            />
                                    </div> 
                              </div>
                            </div>
                            <div className="column">
                              <div>
                                        <input
                                          className="input is-primary"
                                          type="tel"
                                          name="cvc"
                                          placeholder="CVC"
                                          onKeyUp={this.handleInputChange}
                                          onFocus={this.handleInputFocus}
                                          required
                                        />
                                  </div> 
                              </div> 
                               
                                      <div>    
                                      {/* <div className="form-pay-button">
                                        <button className="button is-success is-focused"> Submit</button>
                                    </div>     */}
                           </div>
                      </div>
                      <div className="input-payment-public">
                                <input
                                      className="input is-primary"
                                      type="text"
                                      name="name"
                                      placeholder="Name"
                                      ref={input => this.name = input}
                                      onKeyUp={this.handleInputChange}
                                      onFocus={this.handleInputFocus}
                                      pattern="[a-z]{1,15}"
                                      required
                                />
                          </div>

                    <hr className="payment-public-line"/>
                    <div className="columns">
                      <div className="column is-half">
                         <div className="field">
                          <div className="control">
                            <input className="input is-primary" type="text" placeholder="first name"/>
                          </div>
                        </div>
                      </div>
                      <div className="column is-half">
                         <div className="field">
                          <div className="control">
                            <input className="input is-primary" type="text" placeholder="Last name"/>
                          </div>
                        </div>
                      </div>
                      
                    </div>
                    <div className="columns">
                      <div className="column is-half">
                         <div className="field">
                          <div className="control">
                            <input className="input is-primary" type="text" placeholder="Phone Number"/>
                          </div>
                        </div>
                      </div>
                      <div className="column is-half">
                      <div className="field">
                          <div className="control">
                            <input className="input is-primary" type="text" placeholder="Email"/>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="columns">
                      <div className="column is-half">
                         <div className="field">
                          <div className="control">
                            <input className="input is-primary" type="text" placeholder="Class name"/>
                          </div>
                        </div>
                      </div>
                      
                    </div>
                    <div className="payment-footer-public">
                        <a className="button is-success payment-butom-subit">Continue </a>
                        <a className="button is-link">Back</a>
                    </div>  

                  </form>
                 </div>  
             </div>  
         </div>  
      
          {/* <p className="heart">
            <i class="fa fa-heart fa-4x fa-beat"></i>
        </p> */}

      
      
     </div> 
    );
  }




}

export default Payment;


// WEBPACK FOOTER //
// ./src/component/payment/payment.js